export const PRODUCT_KEYS = {
  all: ["product"] as const,
  bySkus: (skus: string[]) => [...PRODUCT_KEYS.all, "bySkus", [...skus].sort()] as const,
};
